import React from "react";
import { useEphemeralWsRequest } from "./useEphemeralWsRequest";
import { useIdeasNodeStore } from "../stores/ideaNodesStore";
import { getBaseSummarySessionWsUrl } from "@sharpana/shared/utils/wsUrlUtils";

/**
 * Hook that wraps useEphemeralWsRequest with session metadata enrichment
 * This is the recommended hook for SummarySession related WebSocket requests
 */
export function useSessionEphemeralWsRequest<TIn, TOut>() {
  const { request, lastMessage, start, cancel, state, messages } = useEphemeralWsRequest<TIn, TOut>();
  const sessionMetadata = useIdeasNodeStore(state => state.sessionMetadata);
  const summarizationMode = useIdeasNodeStore(state => state.summarizationMode);

  const startSessionRequest = React.useCallback((payload: TIn, token?: string) => {
    // Enrich payload with session metadata
    // Set required backend fields explicitly to avoid spreading issues
    const enrichedPayload = {
      ...payload,
      ...sessionMetadata,
      summarization_mode: summarizationMode,
    } as TIn;

    // Get the base WebSocket URL from the centralized utility
    const wsUrl = getBaseSummarySessionWsUrl();
    
    console.log("useSessionEphemeralWsRequest - Sending message:", enrichedPayload);
    console.log("Using WebSocket URL:", wsUrl);
    
    return start({
      url: wsUrl,
      payload: enrichedPayload,
      token,
      timeoutMs: 90000, // 90 second timeout
    });
  }, [start, sessionMetadata, summarizationMode]);

  return {
    request,
    lastMessage,
    startSessionRequest,
    cancel,
    state,
    messages,
  };
}
